import $ from 'jquery'

export function fixLayout () {
  $('body').layout('fix')
}
